<template lang="pug">
  .button
    span.icon-wrap
      font-awesome-icon.icon(:icon="icon")
    | {{text}}
</template>
<script>
export default {
  props: {
    text: String,
    icon: {
      type: Array,
      default(){
        return ['fa', 'play']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button{
    color: white;
    display: flex;
    font-family: 'Open Sans', sans-serif;
    font-size: 25px;
    cursor: pointer;
    text-align: center;
    position: relative;
    align-items: center;
    min-height: 68px;
    padding-right: 1rem;
    margin-right: 5px;
    &:after{
      content: '';
      border: 2px solid white;
      position: absolute;
      left: 0;
      width: 68px;
      height: 68px;
      top: 0;
      border-radius: 50px;
      transition: all .3s;
    }
    .icon-wrap{
      width: 34px;
      margin-right: 24px;
      margin-left: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .icon{
      padding: 0;
    }
    &:hover{
      &:after{
        width: 102%;
      }
    }
    @media screen and (max-width: 800px){
      font-size: 14px;
      min-height: 34px;
      &:after{
        border: 1px solid white;
        content: '';
        width: 34px;
        height: 34px;
        top: 0;
        border-radius: 50px;
        transition: all .3s;
      }
      .icon-wrap{
        margin-right: 6px;
        margin-left: 0px;
      }
    }
  }
</style>
